import { Pipe, PipeTransform } from '@angular/core';
import { Sim, SimWithUsage } from '../models/sim';
import { SelectItem } from 'primeng/api/selectitem';

@Pipe({
  name: 'uniqueModems'
})
export class UniqueModemsPipe implements PipeTransform {

  transform(sims: Sim[] | SimWithUsage[]): SelectItem[] {
    return sims ? [...new Set(sims.filter((sim: Sim | SimWithUsage) => !!sim.link)
      .map((sim: Sim | SimWithUsage) => sim.link))
    ].filter(link => !!link)
    .sort((l1, l2) => parseInt(l1.replace('CELL_', '')) - parseInt(l2.replace('CELL_', '')))
    .map(link => {
      return {
        label: link ? link.replace('CELL_', '') : '',
        value: link
      }
    }) : [];
  }
}
